import { MC_DEVICE_TYPE, MC_SOFTWARE_TYPE } from 'config/const';

// Expand only after filtering physical controllers by the user's department.
export function monitoringControllers(controllers) {
  return controllers.flatMap(parent => {
    if (parent.softwareType !== MC_SOFTWARE_TYPE.B2_2) return [parent];
    const powerFault = parent.fault === 'POWER_SOURCE_BATTERY' ? parent.fault : null;
    const units = (parent.sensorUnits || []).filter(sensor => sensor.enabled && !sensor.deletionPending).map(sensor => ({
      id: sensor.id,
      guid: `b22:${sensor.id}`,
      name: sensor.name,
      softwareType: MC_SOFTWARE_TYPE.B2_2,
      deviceType: sensor.deviceType || MC_DEVICE_TYPE.REFRIGERATION,
      area: parent.area,
      stLocation: parent.stLocation,
      parentId: parent.id,
      parentGuid: parent.guid,
      parentName: parent.name,
      isB22Sensor: true,
      isConnected: !!parent.isConnected,
      turnOnDate: parent.isConnected ? (sensor.lastSeen || true) : null,
      turnOffDate: parent.isConnected ? null : (parent.turnOffDate || true),
      fault: powerFault || sensor.fault,
      faults: [...new Set([powerFault, sensor.fault].filter(fault => fault && fault !== 'none'))],
      temperature: sensor.temperature,
      lastSeen: sensor.lastSeen,
      notification: sensor.notification,
      rangeSettings: { minTemp: sensor.minTemp, maxTemp: sensor.maxTemp, faultDelayTime: sensor.faultDelayTime },
      seq: Number(parent.seq || 0) + (sensor.port * 10 + sensor.slot) / 1000,
    }));
    return units;
  });
}

export function applySensorUpdate(controllers, update) {
  if (!update?.sensor?.id) return controllers;
  return controllers.map(parent => {
    if (parent.guid !== update.parentGuid || parent.softwareType !== MC_SOFTWARE_TYPE.B2_2) return parent;
    const units = parent.sensorUnits || [];
    if (update.deleted || update.sensor.deletionPending) return { ...parent, sensorUnits: units.filter(sensor => sensor.id !== update.sensor.id) };
    const exists = units.some(sensor => sensor.id === update.sensor.id);
    return { ...parent, sensorUnits: exists
      ? units.map(sensor => sensor.id === update.sensor.id ? { ...sensor, ...update.sensor } : sensor)
      : [...units, update.sensor] };
  });
}
